/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { LegalForm } from './legal-form';
// May contain unused imports in some cases
// @ts-ignore
import type { TaxConfigDTO } from './tax-config-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { TenantCountryCodeEnum } from './tenant-country-code-enum';

/**
 * 
 * @export
 * @interface TenantDTO
 */
export interface TenantDTO {
    /**
     * The country of the tenant in ISO31661Alpha2 format. Determines tax/legal context and country-specific benefit models (e.g., German vs. Austrian lunch benefit rules).
     * @type {TenantCountryCodeEnum}
     * @memberof TenantDTO
     */
    'countryCode': TenantCountryCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'tenantStatus': TenantDTOTenantStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'activeBenefits'?: Array<TenantDTOActiveBenefitsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'flexBenefits'?: Array<TenantDTOFlexBenefitsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'nonCashBenefits': Array<TenantDTONonCashBenefitsEnum>;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'source'?: TenantDTOSourceEnum;
    /**
     * The country of the tenant\'s address in ISO31661Alpha2 format
     * @type {string}
     * @memberof TenantDTO
     */
    'addressCountry'?: string;
    /**
     * 
     * @type {LegalForm}
     * @memberof TenantDTO
     */
    'legalForm'?: LegalForm;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lunchTaxationType'?: TenantDTOLunchTaxationTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'reportBenefitList'?: Array<TenantDTOReportBenefitListEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'reportDetailBenefitList'?: Array<TenantDTOReportDetailBenefitListEnum>;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'couponOrderAutomationBehaviour'?: TenantDTOCouponOrderAutomationBehaviourEnum;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'preferredPortal': TenantDTOPreferredPortalEnum;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'legalTermsAction'?: TenantDTOLegalTermsActionEnum;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'hrSystemType'?: TenantDTOHrSystemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'billingType'?: TenantDTOBillingTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     * @deprecated
     */
    'showStatisticsAtTop': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'additionalFeatures'?: Array<TenantDTOAdditionalFeaturesEnum>;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'displayVisualisation': TenantDTODisplayVisualisationEnum;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'invoiceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'mailDomain': string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'mail': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'invoiceEmailList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'imageURL'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'imageURLDark'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'streetLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'postalCode'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'completedTutorialSteps'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'mailIsSent'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TenantDTO
     */
    'lodasExportTenant'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDTO
     */
    'lodasExportConsultant'?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasExportType'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeTaxFree'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeTaxable'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeMobilityTaxFree'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeMobilityTaxable'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeSalaryReduction'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeCoupons'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeFitness'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeWellpass'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeCreditCard'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeGifts'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeIncentives'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeInternet'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeKita'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeRecreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeATLunch'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeATMobility'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeBikeleasingBenefitInKind'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lodasSalaryTypeBikeleasingSalaryConversion'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lunchRestrictionHint'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'lunchRestrictionReasonText'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'lunchRestrictionPostalCode'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'mobilityRestrictionHint'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'mobilityRestrictionReasonText'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'recreationRestrictionHint'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'recreationRestrictionReasonText'?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantDTO
     */
    'lunchPeriodCloseDelay'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDTO
     */
    'couponBudget'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'reportEmailList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'registrationCode'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'couponPackages'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantDTO
     */
    'excludedCouponPackages'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TenantDTO
     */
    'couponOrderDeadline'?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'couponFallbackDefinitionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     */
    'enableAutomatedBudgetOrders'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'bikeleasingCrmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'bikeleasingCompanyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'accountServiceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'bikePlatformName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'bikePlatformUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     */
    'leasingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     */
    'inBikeleasingOnboarding'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     */
    'bavShowTerms'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'legalTermsLastConsentDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     */
    'sepa'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'sepaMandate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'bic'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'sepaDebtorName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'hrSystemApiKey'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     */
    'hrSystemApiSecret'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'hrSystemLastSync'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     */
    'hrSystemInstantInvite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'hrSystemSyncError'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'hrSystemMailFilter'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'hrSystemSubcompanyFilter'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     */
    'hrSystemProbonioFilter'?: boolean;
    /**
     * 
     * @type {TaxConfigDTO}
     * @memberof TenantDTO
     */
    'taxConfig'?: TaxConfigDTO;
    /**
     * 
     * @type {number}
     * @memberof TenantDTO
     */
    'employeeCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantDTO
     */
    'activeEmployeeCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     */
    'accountingAutoSend'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'accountingId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'accountingCustomerNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'internalNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'primaryColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'secondaryColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'backgroundColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'primaryColorDark'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'secondaryColorDark'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'backgroundColorDark'?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantDTO
     */
    'companySize'?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'referredByAccountExecutiveId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'referredBySdrId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'referredByAccountManagerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'referredByPartner'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     */
    'notificationsActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     */
    'verifiedBankAccount'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'paycenterCompanyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'paycenterIBAN'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'parentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'atFiscalYearEnd'?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantDTO
     */
    'atLunchDayExpiryMonths': number;
    /**
     * 
     * @type {number}
     * @memberof TenantDTO
     */
    'atCloseDelay': number;
    /**
     * 
     * @type {number}
     * @memberof TenantDTO
     */
    'atMobilityPeriodCloseDelay': number;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'itLeasingCompanyLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    'carCompanyCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDTO
     */
    'wellpassMigrationActive'?: boolean;
}

export const TenantDTOTenantStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Deleted: 'DELETED'
} as const;

export type TenantDTOTenantStatusEnum = typeof TenantDTOTenantStatusEnum[keyof typeof TenantDTOTenantStatusEnum];
export const TenantDTOActiveBenefitsEnum = {
    Bav: 'BAV',
    Lunch: 'LUNCH',
    Coupons: 'COUPONS',
    CouponsV2: 'COUPONS_V2',
    Mobility: 'MOBILITY',
    Gifts: 'GIFTS',
    Internet: 'INTERNET',
    Bike: 'BIKE',
    News: 'NEWS',
    Flex: 'FLEX',
    Recreation: 'RECREATION',
    Bikeleasing: 'BIKELEASING',
    BikeleasingV2: 'BIKELEASING_V2',
    Fitness: 'FITNESS',
    Kita: 'KITA',
    CreditCard: 'CREDIT_CARD',
    DiscountCode: 'DISCOUNT_CODE',
    Custom: 'CUSTOM',
    AtLunch: 'AT_LUNCH',
    AtMobility: 'AT_MOBILITY',
    Car: 'CAR',
    ItLeasing: 'IT_LEASING',
    Wellpass: 'WELLPASS'
} as const;

export type TenantDTOActiveBenefitsEnum = typeof TenantDTOActiveBenefitsEnum[keyof typeof TenantDTOActiveBenefitsEnum];
export const TenantDTOFlexBenefitsEnum = {
    Bav: 'BAV',
    Lunch: 'LUNCH',
    Coupons: 'COUPONS',
    CouponsV2: 'COUPONS_V2',
    Mobility: 'MOBILITY',
    Gifts: 'GIFTS',
    Internet: 'INTERNET',
    Bike: 'BIKE',
    News: 'NEWS',
    Flex: 'FLEX',
    Recreation: 'RECREATION',
    Bikeleasing: 'BIKELEASING',
    BikeleasingV2: 'BIKELEASING_V2',
    Fitness: 'FITNESS',
    Kita: 'KITA',
    CreditCard: 'CREDIT_CARD',
    DiscountCode: 'DISCOUNT_CODE',
    Custom: 'CUSTOM',
    AtLunch: 'AT_LUNCH',
    AtMobility: 'AT_MOBILITY',
    Car: 'CAR',
    ItLeasing: 'IT_LEASING',
    Wellpass: 'WELLPASS'
} as const;

export type TenantDTOFlexBenefitsEnum = typeof TenantDTOFlexBenefitsEnum[keyof typeof TenantDTOFlexBenefitsEnum];
export const TenantDTONonCashBenefitsEnum = {
    Coupons: 'COUPONS',
    Fitness: 'FITNESS',
    CreditCard: 'CREDIT_CARD',
    Wellpass: 'WELLPASS'
} as const;

export type TenantDTONonCashBenefitsEnum = typeof TenantDTONonCashBenefitsEnum[keyof typeof TenantDTONonCashBenefitsEnum];
export const TenantDTOSourceEnum = {
    Probonio: 'Probonio',
    Bikeleasing: 'Bikeleasing',
    Import: 'Import'
} as const;

export type TenantDTOSourceEnum = typeof TenantDTOSourceEnum[keyof typeof TenantDTOSourceEnum];
export const TenantDTOLunchTaxationTypeEnum = {
    SimpleTaxation: 'SIMPLE_TAXATION',
    FlatRateTaxation: 'FLAT_RATE_TAXATION'
} as const;

export type TenantDTOLunchTaxationTypeEnum = typeof TenantDTOLunchTaxationTypeEnum[keyof typeof TenantDTOLunchTaxationTypeEnum];
export const TenantDTOReportBenefitListEnum = {
    Bav: 'BAV',
    Lunch: 'LUNCH',
    Coupons: 'COUPONS',
    CouponsV2: 'COUPONS_V2',
    Mobility: 'MOBILITY',
    Gifts: 'GIFTS',
    Internet: 'INTERNET',
    Bike: 'BIKE',
    News: 'NEWS',
    Flex: 'FLEX',
    Recreation: 'RECREATION',
    Bikeleasing: 'BIKELEASING',
    BikeleasingV2: 'BIKELEASING_V2',
    Fitness: 'FITNESS',
    Kita: 'KITA',
    CreditCard: 'CREDIT_CARD',
    DiscountCode: 'DISCOUNT_CODE',
    Custom: 'CUSTOM',
    AtLunch: 'AT_LUNCH',
    AtMobility: 'AT_MOBILITY',
    Car: 'CAR',
    ItLeasing: 'IT_LEASING',
    Wellpass: 'WELLPASS'
} as const;

export type TenantDTOReportBenefitListEnum = typeof TenantDTOReportBenefitListEnum[keyof typeof TenantDTOReportBenefitListEnum];
export const TenantDTOReportDetailBenefitListEnum = {
    Bav: 'BAV',
    Lunch: 'LUNCH',
    Coupons: 'COUPONS',
    CouponsV2: 'COUPONS_V2',
    Mobility: 'MOBILITY',
    Gifts: 'GIFTS',
    Internet: 'INTERNET',
    Bike: 'BIKE',
    News: 'NEWS',
    Flex: 'FLEX',
    Recreation: 'RECREATION',
    Bikeleasing: 'BIKELEASING',
    BikeleasingV2: 'BIKELEASING_V2',
    Fitness: 'FITNESS',
    Kita: 'KITA',
    CreditCard: 'CREDIT_CARD',
    DiscountCode: 'DISCOUNT_CODE',
    Custom: 'CUSTOM',
    AtLunch: 'AT_LUNCH',
    AtMobility: 'AT_MOBILITY',
    Car: 'CAR',
    ItLeasing: 'IT_LEASING',
    Wellpass: 'WELLPASS'
} as const;

export type TenantDTOReportDetailBenefitListEnum = typeof TenantDTOReportDetailBenefitListEnum[keyof typeof TenantDTOReportDetailBenefitListEnum];
export const TenantDTOCouponOrderAutomationBehaviourEnum = {
    Default: 'DEFAULT',
    ForAllUsers: 'FOR_ALL_USERS',
    Disabled: 'DISABLED'
} as const;

export type TenantDTOCouponOrderAutomationBehaviourEnum = typeof TenantDTOCouponOrderAutomationBehaviourEnum[keyof typeof TenantDTOCouponOrderAutomationBehaviourEnum];
export const TenantDTOPreferredPortalEnum = {
    Bikeleasing: 'BIKELEASING',
    OnePortal: 'ONE_PORTAL',
    Neutral: 'NEUTRAL'
} as const;

export type TenantDTOPreferredPortalEnum = typeof TenantDTOPreferredPortalEnum[keyof typeof TenantDTOPreferredPortalEnum];
export const TenantDTOLegalTermsActionEnum = {
    None: 'NONE',
    Skip: 'SKIP',
    Consent: 'CONSENT'
} as const;

export type TenantDTOLegalTermsActionEnum = typeof TenantDTOLegalTermsActionEnum[keyof typeof TenantDTOLegalTermsActionEnum];
export const TenantDTOHrSystemTypeEnum = {
    Personio: 'PERSONIO'
} as const;

export type TenantDTOHrSystemTypeEnum = typeof TenantDTOHrSystemTypeEnum[keyof typeof TenantDTOHrSystemTypeEnum];
export const TenantDTOBillingTypeEnum = {
    MaxPrice: 'MAX_PRICE',
    Static: 'STATIC',
    PerBenefit: 'PER_BENEFIT',
    Free: 'FREE',
    MaxPriceBenefitActivation: 'MAX_PRICE_BENEFIT_ACTIVATION'
} as const;

export type TenantDTOBillingTypeEnum = typeof TenantDTOBillingTypeEnum[keyof typeof TenantDTOBillingTypeEnum];
export const TenantDTOAdditionalFeaturesEnum = {
    CorporateColors: 'CORPORATE_COLORS',
    Kombo: 'KOMBO',
    ChatBot: 'CHAT_BOT',
    SourceFilter: 'SOURCE_FILTER'
} as const;

export type TenantDTOAdditionalFeaturesEnum = typeof TenantDTOAdditionalFeaturesEnum[keyof typeof TenantDTOAdditionalFeaturesEnum];
export const TenantDTODisplayVisualisationEnum = {
    Top: 'TOP',
    Bottom: 'BOTTOM',
    None: 'NONE'
} as const;

export type TenantDTODisplayVisualisationEnum = typeof TenantDTODisplayVisualisationEnum[keyof typeof TenantDTODisplayVisualisationEnum];


